var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content mrv-page" },
    [
      _c("div", { staticClass: "mrv-toolbar-card row-data" }, [
        _c(
          "div",
          { staticClass: "mrv-toolbar-section mrv-toolbar-section--filter" },
          [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "mrv-filter-grid" },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "mrv-filter-control",
                    attrs: { placeholder: "Trạng thái", clearable: "" },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.searchRequest.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchRequest, "status", $$v)
                      },
                      expression: "searchRequest.status",
                    },
                  },
                  _vm._l(_vm.kidStatusList, function (item) {
                    return _c("el-option", {
                      key: item.key,
                      attrs: { value: item.key, label: item.value },
                    })
                  }),
                  1
                ),
                _vm.isClassTab
                  ? _c(
                      "el-select",
                      {
                        staticClass:
                          "mrv-filter-control mrv-filter-control--grade",
                        attrs: { placeholder: "Chọn khối" },
                        on: { change: _vm.handleGradeChange },
                        model: {
                          value: _vm.searchRequest.idGrade,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchRequest, "idGrade", $$v)
                          },
                          expression: "searchRequest.idGrade",
                        },
                      },
                      _vm._l(_vm.gradeOfSchoolList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { value: item.id, label: item.gradeName },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm.isClassTab
                  ? _c(
                      "el-select",
                      {
                        staticClass: "mrv-filter-control",
                        attrs: { placeholder: "Chọn lớp" },
                        on: { change: _vm.handleSearch },
                        model: {
                          value: _vm.searchRequest.idClass,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchRequest, "idClass", $$v)
                          },
                          expression: "searchRequest.idClass",
                        },
                      },
                      _vm._l(_vm.classList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { value: item.id, label: item.className },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm.isGroupTab
                  ? _c(
                      "el-select",
                      {
                        staticClass:
                          "mrv-filter-control mrv-filter-control--group",
                        attrs: { placeholder: "Chọn nhóm" },
                        on: { change: _vm.handleSearch },
                        model: {
                          value: _vm.searchRequest.idGroup,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchRequest, "idGroup", $$v)
                          },
                          expression: "searchRequest.idGroup",
                        },
                      },
                      _vm._l(_vm.kidGroupList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { value: item.id, label: item.nameGroup },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm.isPackageTab
                  ? _c(
                      "el-select",
                      {
                        staticClass:
                          "mrv-filter-control mrv-filter-control--group",
                        attrs: { placeholder: "Chọn gói" },
                        on: { change: _vm.handleSearch },
                        model: {
                          value: _vm.searchRequest.idPackage,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchRequest, "idPackage", $$v)
                          },
                          expression: "searchRequest.idPackage",
                        },
                      },
                      _vm._l(_vm.packageDropdownList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { value: item.id, label: item.name },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _c("el-input", {
                  staticClass: "mrv-search-input",
                  attrs: { placeholder: "Nhập tên học sinh...", clearable: "" },
                  on: { clear: _vm.handleSearch },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.handleSearch.apply(null, arguments)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c("el-button", {
                            attrs: { icon: "el-icon-search" },
                            on: { click: _vm.handleSearch },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.searchRequest.fullName,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchRequest, "fullName", $$v)
                    },
                    expression: "searchRequest.fullName",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "mrv-table-card row-data" },
        [
          _vm._m(1),
          _c(
            "el-tabs",
            {
              staticClass: "sk-tabs",
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabChange },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { name: "CLASS_REGISTER" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("i", { staticClass: "el-icon-s-check" }),
                    _vm._v(" Đăng ký theo lớp\n        "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mrv-table-wrapper" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading",
                            },
                          ],
                          ref: "tableClassRegisterRef",
                          staticClass: "sk-table",
                          attrs: {
                            data: _vm.tab1DataList,
                            "empty-text": _vm.emptyText,
                            "element-loading-text": _vm.$tableLoading,
                            "element-loading-spinner": "el-icon-loading",
                            "element-loading-background": "rgba(255,255,255,0)",
                            "highlight-current-row": "",
                            "max-height": _vm.$tableMaxHeight,
                            border: "",
                          },
                          on: { "selection-change": _vm.handleSelectionChange },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "selection",
                              align: "center",
                              width: "50",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "STT",
                              width: "55",
                              align: "center",
                              fixed: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "fullName",
                              label: "Họ tên",
                              "min-width": "170",
                              fixed: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Ngày sinh",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm._f("formatDate")(row.birthDay))
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Trạng thái",
                              align: "center",
                              width: "115",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.kidStatusTagType(
                                            row.kidStatus
                                          ),
                                          size: "mini",
                                          effect: "light",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.kidStatusLabel(row.kidStatus)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._l(_vm.tab1PackageList, function (pkg) {
                            return _c(
                              "el-table-column",
                              {
                                key: pkg.id,
                                attrs: { align: "center", "min-width": "130" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm.getPackageItem(
                                            row.fnKidsPackageList,
                                            pkg.id
                                          )
                                            ? _c("el-checkbox", {
                                                attrs: {
                                                  value: _vm.getPackageItem(
                                                    row.fnKidsPackageList,
                                                    pkg.id
                                                  ).active,
                                                },
                                                on: {
                                                  change: (val) =>
                                                    _vm.setPackageActive(
                                                      row,
                                                      pkg.id,
                                                      val
                                                    ),
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "template",
                                  { slot: "header" },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "top",
                                          width: "200",
                                          trigger: "hover",
                                          content: pkg.name,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "mrv-col-name",
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [_vm._v(_vm._s(pkg.name))]
                                        ),
                                      ]
                                    ),
                                    _c("br"),
                                    _c("el-checkbox", {
                                      attrs: {
                                        value: _vm.getPackageCheckClass(pkg.id),
                                      },
                                      on: {
                                        change: (val) =>
                                          _vm.handleHeaderCheckClass(
                                            pkg.id,
                                            val
                                          ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              2
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Tác vụ",
                              fixed: "right",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleSaveOne(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Lưu\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { name: "CLASS_DETAIL" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("i", { staticClass: "el-icon-tickets" }),
                    _vm._v(" Chi tiết theo lớp\n        "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mrv-table-wrapper" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading",
                            },
                          ],
                          ref: "tableClassDetailRef",
                          staticClass: "sk-table",
                          attrs: {
                            data: _vm.tab2DataList,
                            "empty-text": _vm.emptyText,
                            "element-loading-text": _vm.$tableLoading,
                            "element-loading-spinner": "el-icon-loading",
                            "element-loading-background": "rgba(255,255,255,0)",
                            "cell-style": _vm.rowStyleExpanded,
                            "max-height": _vm.$tableMaxHeight,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "expand", width: "1" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "mrv-expand-wrapper" },
                                      [
                                        _c(
                                          "el-table",
                                          {
                                            staticClass:
                                              "sk-table mrv-inner-table",
                                            attrs: {
                                              data: row.revenueManagementResponses,
                                              "empty-text": _vm.emptyText,
                                              "cell-style":
                                                _vm.rowStyleCategory,
                                              border: "",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                type: "index",
                                                label: "STT",
                                                width: "50",
                                                align: "center",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Tên khoản",
                                                prop: "revenueName",
                                                "min-width": "160",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Kích hoạt",
                                                align: "center",
                                                width: "90",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c("i", {
                                                          class: r.active
                                                            ? "el-icon-circle-check"
                                                            : "el-icon-close",
                                                          style: {
                                                            color: r.active
                                                              ? "#16a34a"
                                                              : "#dc2626",
                                                            fontSize: "18px",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Loại",
                                                align: "center",
                                                width: "85",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c(
                                                          "el-tag",
                                                          {
                                                            attrs: {
                                                              type:
                                                                r.category ===
                                                                "IN"
                                                                  ? "success"
                                                                  : "info",
                                                              size: "mini",
                                                              effect: "light",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  r.category ===
                                                                    "IN"
                                                                    ? "Thu"
                                                                    : "Chi"
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Công thức",
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.hasFormula
                                                          ? _c(
                                                              "el-tag",
                                                              {
                                                                attrs: {
                                                                  type: "warning",
                                                                  size: "mini",
                                                                  effect:
                                                                    "dark",
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-s-operation",
                                                                }),
                                                                _vm._v(
                                                                  " Có\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Biểu thức",
                                                "min-width": "140",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.hasFormula &&
                                                        r.formulaExpression
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-formula-badge",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      r.formulaExpression
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "SL",
                                                align: "center",
                                                width: "65",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.formatQuantity(
                                                                r.quantity
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Đơn vị",
                                                prop: "unit",
                                                align: "center",
                                                width: "90",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Đơn giá",
                                                align: "right",
                                                width: "135",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "mrv-money",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatCurrency"
                                                                )(r.price)
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Giảm giá",
                                                align: "center",
                                                width: "80",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c("i", {
                                                          class: r.discount
                                                            ? "el-icon-circle-check"
                                                            : "el-icon-close",
                                                          style: {
                                                            color: r.discount
                                                              ? "#16a34a"
                                                              : "#dc2626",
                                                            fontSize: "16px",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Loại giảm",
                                                align: "center",
                                                width: "100",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.discountType ===
                                                        "PERCENT"
                                                          ? _c("span", [
                                                              _vm._v("%"),
                                                            ])
                                                          : r.discountType ===
                                                            "MONEY"
                                                          ? _c("span", [
                                                              _vm._v("VNĐ"),
                                                            ])
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Giá trị giảm",
                                                align: "right",
                                                width: "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.discount &&
                                                        r.discountType ===
                                                          "MONEY"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-money",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatCurrency"
                                                                      )(
                                                                        r.discountNumber
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : r.discount &&
                                                            r.discountType ===
                                                              "PERCENT"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-money",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      r.discountNumber
                                                                    ) +
                                                                    "%\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Tác vụ",
                                                width: "80",
                                                align: "center",
                                                fixed: "right",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            attrs: {
                                                              content:
                                                                "Chỉnh sửa",
                                                              placement: "top",
                                                            },
                                                          },
                                                          [
                                                            _c("el-button", {
                                                              attrs: {
                                                                type: "primary",
                                                                icon: "el-icon-edit",
                                                                size: "mini",
                                                                circle: "",
                                                                plain: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openEditDetailDialog(
                                                                      r
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "STT",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "fullName",
                              label: "Họ tên",
                              "min-width": "200",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Ngày sinh",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm._f("formatDate")(row.birthDay))
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Trạng thái",
                              align: "center",
                              width: "115",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.kidStatusTagType(
                                            row.kidStatus
                                          ),
                                          size: "mini",
                                          effect: "light",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.kidStatusLabel(row.kidStatus)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Số khoản",
                              align: "center",
                              width: "90",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "mrv-revenue-count" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              (
                                                row.revenueManagementResponses ||
                                                []
                                              ).length
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Tác vụ",
                              width: "110",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row, $index }) {
                                  return [
                                    (row.revenueManagementResponses || [])
                                      .length > 0
                                      ? _c(
                                          "span",
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content: row.expandRow
                                                    ? "Thu gọn"
                                                    : "Mở rộng",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("el-button", {
                                                  attrs: {
                                                    type: row.expandRow
                                                      ? "warning"
                                                      : "primary",
                                                    icon: row.expandRow
                                                      ? "el-icon-arrow-up"
                                                      : "el-icon-arrow-down",
                                                    size: "mini",
                                                    circle: "",
                                                    plain: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleToggleExpandClass(
                                                        $index,
                                                        row
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { name: "GROUP_REGISTER" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("i", { staticClass: "el-icon-s-check" }),
                    _vm._v(" Đăng ký theo nhóm\n        "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mrv-table-wrapper" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading",
                            },
                          ],
                          ref: "tableGroupRegisterRef",
                          staticClass: "sk-table",
                          attrs: {
                            data: _vm.tab3DataList,
                            "empty-text": _vm.emptyText,
                            "element-loading-text": _vm.$tableLoading,
                            "element-loading-spinner": "el-icon-loading",
                            "element-loading-background": "rgba(255,255,255,0)",
                            "highlight-current-row": "",
                            "max-height": _vm.$tableMaxHeight,
                            border: "",
                          },
                          on: { "selection-change": _vm.handleSelectionChange },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "selection",
                              align: "center",
                              width: "50",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "STT",
                              width: "55",
                              align: "center",
                              fixed: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "fullName",
                              label: "Họ tên",
                              "min-width": "170",
                              fixed: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Ngày sinh",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm._f("formatDate")(row.birthDay))
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Trạng thái",
                              align: "center",
                              width: "115",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.kidStatusTagType(
                                            row.kidStatus
                                          ),
                                          size: "mini",
                                          effect: "light",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.kidStatusLabel(row.kidStatus)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._l(_vm.tab3PackageList, function (pkg) {
                            return _c(
                              "el-table-column",
                              {
                                key: pkg.id,
                                attrs: { align: "center", "min-width": "130" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm.getPackageItem(
                                            row.fnKidsPackageList,
                                            pkg.id
                                          )
                                            ? _c("el-checkbox", {
                                                attrs: {
                                                  value: _vm.getPackageItem(
                                                    row.fnKidsPackageList,
                                                    pkg.id
                                                  ).active,
                                                },
                                                on: {
                                                  change: (val) =>
                                                    _vm.setPackageActive(
                                                      row,
                                                      pkg.id,
                                                      val
                                                    ),
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "template",
                                  { slot: "header" },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "top",
                                          width: "200",
                                          trigger: "hover",
                                          content: pkg.name,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "mrv-col-name",
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [_vm._v(_vm._s(pkg.name))]
                                        ),
                                      ]
                                    ),
                                    _c("br"),
                                    _c("el-checkbox", {
                                      attrs: {
                                        value: _vm.getPackageCheckGroup(pkg.id),
                                      },
                                      on: {
                                        change: (val) =>
                                          _vm.handleHeaderCheckGroup(
                                            pkg.id,
                                            val
                                          ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              2
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Tác vụ",
                              fixed: "right",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleSaveOne(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Lưu\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { name: "GROUP_DETAIL" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("i", { staticClass: "el-icon-tickets" }),
                    _vm._v(" Chi tiết theo nhóm\n        "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mrv-table-wrapper" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading",
                            },
                          ],
                          ref: "tableGroupDetailRef",
                          staticClass: "sk-table",
                          attrs: {
                            data: _vm.tab4DataList,
                            "empty-text": _vm.emptyText,
                            "element-loading-text": _vm.$tableLoading,
                            "element-loading-spinner": "el-icon-loading",
                            "element-loading-background": "rgba(255,255,255,0)",
                            "cell-style": _vm.rowStyleExpanded,
                            "max-height": _vm.$tableMaxHeight,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "expand", width: "1" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "mrv-expand-wrapper" },
                                      [
                                        _c(
                                          "el-table",
                                          {
                                            staticClass:
                                              "sk-table mrv-inner-table",
                                            attrs: {
                                              data: row.revenueManagementResponses,
                                              "empty-text": _vm.emptyText,
                                              "cell-style":
                                                _vm.rowStyleCategory,
                                              border: "",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                type: "index",
                                                label: "STT",
                                                width: "50",
                                                align: "center",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Tên khoản",
                                                prop: "revenueName",
                                                "min-width": "160",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Kích hoạt",
                                                align: "center",
                                                width: "90",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c("i", {
                                                          class: r.active
                                                            ? "el-icon-circle-check"
                                                            : "el-icon-close",
                                                          style: {
                                                            color: r.active
                                                              ? "#16a34a"
                                                              : "#dc2626",
                                                            fontSize: "18px",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Loại",
                                                align: "center",
                                                width: "85",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c(
                                                          "el-tag",
                                                          {
                                                            attrs: {
                                                              type:
                                                                r.category ===
                                                                "IN"
                                                                  ? "success"
                                                                  : "info",
                                                              size: "mini",
                                                              effect: "light",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  r.category ===
                                                                    "IN"
                                                                    ? "Thu"
                                                                    : "Chi"
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Công thức",
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.hasFormula
                                                          ? _c(
                                                              "el-tag",
                                                              {
                                                                attrs: {
                                                                  type: "warning",
                                                                  size: "mini",
                                                                  effect:
                                                                    "dark",
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-s-operation",
                                                                }),
                                                                _vm._v(
                                                                  " Có\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Biểu thức",
                                                "min-width": "140",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.hasFormula &&
                                                        r.formulaExpression
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-formula-badge",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      r.formulaExpression
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "SL",
                                                align: "center",
                                                width: "65",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.formatQuantity(
                                                                r.quantity
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Đơn vị",
                                                prop: "unit",
                                                align: "center",
                                                width: "90",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Đơn giá",
                                                align: "right",
                                                width: "135",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "mrv-money",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatCurrency"
                                                                )(r.price)
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Giảm giá",
                                                align: "center",
                                                width: "80",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c("i", {
                                                          class: r.discount
                                                            ? "el-icon-circle-check"
                                                            : "el-icon-close",
                                                          style: {
                                                            color: r.discount
                                                              ? "#16a34a"
                                                              : "#dc2626",
                                                            fontSize: "16px",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Loại giảm",
                                                align: "center",
                                                width: "100",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.discountType ===
                                                        "PERCENT"
                                                          ? _c("span", [
                                                              _vm._v("%"),
                                                            ])
                                                          : r.discountType ===
                                                            "MONEY"
                                                          ? _c("span", [
                                                              _vm._v("VNĐ"),
                                                            ])
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Giá trị giảm",
                                                align: "right",
                                                width: "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.discount &&
                                                        r.discountType ===
                                                          "MONEY"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-money",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatCurrency"
                                                                      )(
                                                                        r.discountNumber
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : r.discount &&
                                                            r.discountType ===
                                                              "PERCENT"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-money",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      r.discountNumber
                                                                    ) +
                                                                    "%\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Tác vụ",
                                                width: "80",
                                                align: "center",
                                                fixed: "right",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            attrs: {
                                                              content:
                                                                "Chỉnh sửa",
                                                              placement: "top",
                                                            },
                                                          },
                                                          [
                                                            _c("el-button", {
                                                              attrs: {
                                                                type: "primary",
                                                                icon: "el-icon-edit",
                                                                size: "mini",
                                                                circle: "",
                                                                plain: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openEditDetailDialog(
                                                                      r
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "STT",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "fullName",
                              label: "Họ tên",
                              "min-width": "200",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Ngày sinh",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm._f("formatDate")(row.birthDay))
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Trạng thái",
                              align: "center",
                              width: "115",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.kidStatusTagType(
                                            row.kidStatus
                                          ),
                                          size: "mini",
                                          effect: "light",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.kidStatusLabel(row.kidStatus)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Số khoản",
                              align: "center",
                              width: "90",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "mrv-revenue-count" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              (
                                                row.revenueManagementResponses ||
                                                []
                                              ).length
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Tác vụ",
                              width: "110",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row, $index }) {
                                  return [
                                    (row.revenueManagementResponses || [])
                                      .length > 0
                                      ? _c(
                                          "span",
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content: row.expandRow
                                                    ? "Thu gọn"
                                                    : "Mở rộng",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("el-button", {
                                                  attrs: {
                                                    type: row.expandRow
                                                      ? "warning"
                                                      : "primary",
                                                    icon: row.expandRow
                                                      ? "el-icon-arrow-up"
                                                      : "el-icon-arrow-down",
                                                    size: "mini",
                                                    circle: "",
                                                    plain: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleToggleExpandGroup(
                                                        $index,
                                                        row
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { name: "PACKAGE_REGISTER" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("i", { staticClass: "el-icon-s-check" }),
                    _vm._v(" Đăng ký theo gói\n        "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mrv-table-wrapper" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading",
                            },
                          ],
                          ref: "tablePackageRegisterRef",
                          staticClass: "sk-table",
                          attrs: {
                            data: _vm.tab5DataList,
                            "empty-text": _vm.emptyText,
                            "element-loading-text": _vm.$tableLoading,
                            "element-loading-spinner": "el-icon-loading",
                            "element-loading-background": "rgba(255,255,255,0)",
                            "highlight-current-row": "",
                            "max-height": _vm.$tableMaxHeight,
                            border: "",
                          },
                          on: { "selection-change": _vm.handleSelectionChange },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "selection",
                              align: "center",
                              width: "50",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "STT",
                              width: "55",
                              align: "center",
                              fixed: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "fullName",
                              label: "Họ tên",
                              "min-width": "170",
                              fixed: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Ngày sinh",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm._f("formatDate")(row.birthDay))
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Trạng thái",
                              align: "center",
                              width: "115",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.kidStatusTagType(
                                            row.kidStatus
                                          ),
                                          size: "mini",
                                          effect: "light",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.kidStatusLabel(row.kidStatus)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._l(_vm.tab5PackageList, function (pkg) {
                            return _c(
                              "el-table-column",
                              {
                                key: pkg.id,
                                attrs: { align: "center", "min-width": "130" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm.getPackageItem(
                                            row.fnKidsPackageList,
                                            pkg.id
                                          )
                                            ? _c("el-checkbox", {
                                                attrs: {
                                                  value: _vm.getPackageItem(
                                                    row.fnKidsPackageList,
                                                    pkg.id
                                                  ).active,
                                                },
                                                on: {
                                                  change: (val) =>
                                                    _vm.setPackageActive(
                                                      row,
                                                      pkg.id,
                                                      val
                                                    ),
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "template",
                                  { slot: "header" },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "top",
                                          width: "200",
                                          trigger: "hover",
                                          content: pkg.name,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "mrv-col-name",
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [_vm._v(_vm._s(pkg.name))]
                                        ),
                                      ]
                                    ),
                                    _c("br"),
                                    _c("el-checkbox", {
                                      attrs: {
                                        value: _vm.getPackageCheckPackage(
                                          pkg.id
                                        ),
                                      },
                                      on: {
                                        change: (val) =>
                                          _vm.handleHeaderCheckPackage(
                                            pkg.id,
                                            val
                                          ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              2
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Tác vụ",
                              fixed: "right",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleSaveOne(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Lưu\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { name: "PACKAGE_DETAIL" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("i", { staticClass: "el-icon-tickets" }),
                    _vm._v(" Chi tiết theo gói\n        "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mrv-table-wrapper" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading",
                            },
                          ],
                          ref: "tablePackageDetailRef",
                          staticClass: "sk-table",
                          attrs: {
                            data: _vm.tab6DataList,
                            "empty-text": _vm.emptyText,
                            "element-loading-text": _vm.$tableLoading,
                            "element-loading-spinner": "el-icon-loading",
                            "element-loading-background": "rgba(255,255,255,0)",
                            "cell-style": _vm.rowStyleExpanded,
                            "max-height": _vm.$tableMaxHeight,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "expand", width: "1" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "mrv-expand-wrapper" },
                                      [
                                        _c(
                                          "el-table",
                                          {
                                            staticClass:
                                              "sk-table mrv-inner-table",
                                            attrs: {
                                              data: row.revenueManagementResponses,
                                              "empty-text": _vm.emptyText,
                                              "cell-style":
                                                _vm.rowStyleCategory,
                                              border: "",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                type: "index",
                                                label: "STT",
                                                width: "50",
                                                align: "center",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Tên khoản",
                                                prop: "revenueName",
                                                "min-width": "160",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Kích hoạt",
                                                align: "center",
                                                width: "90",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c("i", {
                                                          class: r.active
                                                            ? "el-icon-circle-check"
                                                            : "el-icon-close",
                                                          style: {
                                                            color: r.active
                                                              ? "#16a34a"
                                                              : "#dc2626",
                                                            fontSize: "18px",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Loại",
                                                align: "center",
                                                width: "85",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c(
                                                          "el-tag",
                                                          {
                                                            attrs: {
                                                              type:
                                                                r.category ===
                                                                "IN"
                                                                  ? "success"
                                                                  : "info",
                                                              size: "mini",
                                                              effect: "light",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  r.category ===
                                                                    "IN"
                                                                    ? "Thu"
                                                                    : "Chi"
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Công thức",
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.hasFormula
                                                          ? _c(
                                                              "el-tag",
                                                              {
                                                                attrs: {
                                                                  type: "warning",
                                                                  size: "mini",
                                                                  effect:
                                                                    "dark",
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-s-operation",
                                                                }),
                                                                _vm._v(
                                                                  " Có\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Biểu thức",
                                                "min-width": "140",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.hasFormula &&
                                                        r.formulaExpression
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-formula-badge",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      r.formulaExpression
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "SL",
                                                align: "center",
                                                width: "65",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.formatQuantity(
                                                                r.quantity
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Đơn vị",
                                                prop: "unit",
                                                align: "center",
                                                width: "90",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Đơn giá",
                                                align: "right",
                                                width: "135",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "mrv-money",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatCurrency"
                                                                )(r.price)
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Giảm giá",
                                                align: "center",
                                                width: "80",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c("i", {
                                                          class: r.discount
                                                            ? "el-icon-circle-check"
                                                            : "el-icon-close",
                                                          style: {
                                                            color: r.discount
                                                              ? "#16a34a"
                                                              : "#dc2626",
                                                            fontSize: "16px",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Loại giảm",
                                                align: "center",
                                                width: "100",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.discountType ===
                                                        "PERCENT"
                                                          ? _c("span", [
                                                              _vm._v("%"),
                                                            ])
                                                          : r.discountType ===
                                                            "MONEY"
                                                          ? _c("span", [
                                                              _vm._v("VNĐ"),
                                                            ])
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Giá trị giảm",
                                                align: "right",
                                                width: "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        r.discount &&
                                                        r.discountType ===
                                                          "MONEY"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-money",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatCurrency"
                                                                      )(
                                                                        r.discountNumber
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : r.discount &&
                                                            r.discountType ===
                                                              "PERCENT"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-money",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      r.discountNumber
                                                                    ) +
                                                                    "%\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mrv-text-muted",
                                                              },
                                                              [_vm._v("—")]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Tác vụ",
                                                width: "80",
                                                align: "center",
                                                fixed: "right",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row: r }) {
                                                      return [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            attrs: {
                                                              content:
                                                                "Chỉnh sửa",
                                                              placement: "top",
                                                            },
                                                          },
                                                          [
                                                            _c("el-button", {
                                                              attrs: {
                                                                type: "primary",
                                                                icon: "el-icon-edit",
                                                                size: "mini",
                                                                circle: "",
                                                                plain: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openEditDetailDialog(
                                                                      r
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "STT",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "fullName",
                              label: "Họ tên",
                              "min-width": "200",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Ngày sinh",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm._f("formatDate")(row.birthDay))
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Trạng thái",
                              align: "center",
                              width: "115",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.kidStatusTagType(
                                            row.kidStatus
                                          ),
                                          size: "mini",
                                          effect: "light",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.kidStatusLabel(row.kidStatus)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Số khoản",
                              align: "center",
                              width: "90",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "mrv-revenue-count" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              (
                                                row.revenueManagementResponses ||
                                                []
                                              ).length
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Tác vụ",
                              width: "110",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row, $index }) {
                                  return [
                                    (row.revenueManagementResponses || [])
                                      .length > 0
                                      ? _c(
                                          "span",
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content: row.expandRow
                                                    ? "Thu gọn"
                                                    : "Mở rộng",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("el-button", {
                                                  attrs: {
                                                    type: row.expandRow
                                                      ? "warning"
                                                      : "primary",
                                                    icon: row.expandRow
                                                      ? "el-icon-arrow-up"
                                                      : "el-icon-arrow-down",
                                                    size: "mini",
                                                    circle: "",
                                                    plain: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleToggleExpandPackage(
                                                        $index,
                                                        row
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm.isRegisterTab
            ? _c(
                "div",
                { staticClass: "mrv-save-bottom" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass:
                        "mrv-action-button mrv-action-button--bottom",
                      attrs: { type: "success", loading: _vm.isSavingMany },
                      on: { click: _vm.handleSaveMany },
                    },
                    [
                      _c("i", { staticClass: "el-icon-check" }),
                      _vm._v("\n              Lưu đã chọn\n            "),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("edit-revenue-detail-dialog", {
        ref: "editDetailDialog",
        on: { saved: _vm.refreshCurrentTab },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mrv-card-head" }, [
      _c("div", [
        _c("p", { staticClass: "mrv-card-title" }, [_vm._v("Bộ lọc tìm kiếm")]),
        _c("p", { staticClass: "mrv-card-subtitle" }, [
          _vm._v("Lọc học sinh theo trạng thái, lớp/nhóm và tên."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mrv-card-head mrv-table-head" }, [
      _c("div", [
        _c("p", { staticClass: "mrv-card-title" }, [
          _vm._v("Đăng ký khoản sử dụng"),
        ]),
        _c("p", { staticClass: "mrv-card-subtitle" }, [
          _vm._v(
            "\n          Kích hoạt / hủy kích hoạt khoản thu cho từng học sinh theo lớp hoặc nhóm.\n        "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }